import { useState } from 'react'
import type { ActivityType } from '@hewey/shared'
import { ActivityPlaceholder } from './ActivityPlaceholder.tsx'

type Props = {
	// Null (no photo yet) or a failed load both fall back to the placeholder.
	src: string | null
	seed: string
	type?: ActivityType | null | undefined
	// Applied to the <img>; the placeholder fills the parent itself.
	className?: string | undefined
	loading?: 'lazy' | 'eager'
}

// An activity image that degrades to a deterministic icon placeholder when
// there's no URL or the image fails to load. The image is decorative (empty
// alt) — the activity title alongside it is the accessible label.
export const ActivityImage = ({
	src,
	seed,
	type,
	className,
	loading = 'lazy',
}: Props) => {
	const [broken, setBroken] = useState(false)
	if (!src || broken) {
		return <ActivityPlaceholder seed={seed} type={type} />
	}
	return (
		<img
			src={src}
			alt=""
			className={className}
			loading={loading}
			onError={() => setBroken(true)}
		/>
	)
}
